export enum ReportBlockTypeApiEnum {
    COVERAGE_OVER_TIME = 'COVERAGE_OVER_TIME',
    SENTIMENT_BREAKDOWN = 'SENTIMENT_BREAKDOWN',
    SENTIMENT_TREND = 'SENTIMENT_TREND',
    MEDIA_TYPE_BREAKDOWN = 'MEDIA_TYPE_BREAKDOWN',
    GEOGRAPHY_BREAKDOWN_BY_VOLUME = 'GEOGRAPHY_BREAKDOWN_BY_VOLUME',
    TOP_10_OUTLETS = 'TOP_10_OUTLETS_BY_VOLUME',
    TOP_SOCIAL_INFLUENCERS = 'TOP_SOCIAL_INFLUENCER',
    WORD_CLOUD = 'WORD_CLOUD',
    AUDIENCE_REACH_OVER_TIME = 'AUDIENCE_REACH_OVER_TIME',
    AUDIENCE_REACH_OVER_TIME_COMPARISON = 'AUDIENCE_REACH_OVER_TIME_COMPARISON',
    AUDIENCE_REACH_BY_MEDIA_TYPE = 'AUDIENCE_REACH_BY_MEDIA_TYPE',
    AD_VALUE_EQUIVILANCY = 'AD_VALUE_EQUIVILANCY',
    AD_VALUE_EQUIVILANCY_COMPARISON = 'AD_VALUE_EQUIVILANCY_COMPARISON',
    POSITION_BREAKDOWN = 'POSITION_BREAKDOWN',
    SHARE_OF_VOICE = 'SHARE_OF_VOICE',
    COVERAGE_OVER_TIME_COMPARISON = 'COVERAGE_OVER_TIME_COMPARISON',
    COVERAGE_COMPARISON = 'COVERAGE_COMPARISON',
    SENTIMENT_BREAKDOWN_COMPARISON = 'SENTIMENT_BREAKDOWN_COMPARISON',
    MEDIA_TYPE_BREAKDOWN_COMPARISON = 'MEDIA_TYPE_BREAKDOWN_COMPARISON',
    GEOGRAPHY_BREAKDOWN_COMPARISON = 'GEOGRAPHY_BREAKDOWN_COMPARISON',
    COVERAGE_SUMMARY = 'COVERAGE_SUMMARY',
    COVERAGE_METRIC = 'COVERAGE_METRIC',
    TOP_HASHTAGS = 'TOP_HASH_TAGS',
    COVERAGE_IMPACT_TREND = 'COVERAGE_IMPACT_TREND',
    REFERRAL_TREND = 'REFERRAL_TREND',
    PROMINENCE_OVER_TIME = 'PROMINENCE_OVER_TIME',
    PROMINENCE_BY_REACH = 'PROMINENCE_BY_REACH',
    TOP_SOCIAL_REFERRERS = 'TOP_SOCIAL_REFERRERS',
    TOP_REFERRAL_SOURCES = 'TOP_REFERRAL_SOURCES',
    RECENT_TOPICS = 'RECENT_TOPICS',
    RECENT_TARGETING_ACTIVITY = 'RECENT_TARGETING_ACTIVITY',
    RECENT_DISTRIBUTION_ACTIVITY = 'RECENT_DISTRIBUTION_ACTIVITY',
    RECENT_REPORTS_DISTRIBUTIONS = 'RECENT_REPORTS_DISTRIBUTIONS',
    SOCIAL_COVERAGE_BY_NETWORK = 'SOCIAL_COVERAGE_BY_NETWORK',
    TOP_TERMS = 'TOP_TERMS',
    RECENT_SURGE_ALERTS = 'RECENT_SURGE_ALERTS',
    TOP_MENTIONS = 'TOP_MENTIONS',
    TOP_POSTS = 'TOP_POSTS',
}
